import{m as i}from"./chunk-HBP5N4FR.js";i();function k(r,n){return n.startsWith("/")||(console.error("Link not prepended by / : ",n),n=`/${n}`),r?`${r}${n}`:n}export{k as a};
//# sourceMappingURL=chunk-SEFRTT5O.js.map
